import { ThemeableStack } from "@tamagui/stacks";
import { styled } from "@tamagui/web";
import { getShapeSize } from "./getShapeSize";
const Square = styled(ThemeableStack, {
  name: "Square",
  alignItems: "center",
  justifyContent: "center",
  variants: {
    circular: {
      true: {
        borderRadius: 1e5
      }
    },
    size: {
      "...size": getShapeSize
    }
  }
});
export {
  Square
};
//# sourceMappingURL=Square.js.map
